import * as tslib_1 from "tslib";
import React from 'react';
import trim from 'lodash.trim';
import TagButton from '../TagButton';
import Input from '../../Input';
import { KEY } from '../../types';
import CloseIconBold from '../../Icons/CloseBold';
import { IconSize } from '../../Icons/IconWrap';
import s from './TagsInput.scss';
var MAXIMUM_NUMBER_OF_TAGS = 5;
var defaultProps = {
    tags: [],
};
var TagsInput = /** @class */ (function (_super) {
    tslib_1.__extends(TagsInput, _super);
    function TagsInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: '',
            tags: _this.props.tags || defaultProps.tags,
        };
        _this.refInput = function (input) {
            _this.input = input;
        };
        _this.handleRemoveTag = function (e) {
            _this.removeTag(e.target.value);
            _this.input.focus();
        };
        _this.handleInputKeyDown = function (event) {
            var value = _this.state.value;
            switch (event.which) {
                case KEY.ENTER:
                    _this.addTag(value);
                    break;
                case KEY.BACKSPACE:
                    if (value === '') {
                        _this.popTag();
                    }
                    break;
                default:
            }
        };
        _this.handleInputChange = function (value) {
            _this.setState({ value: value });
        };
        return _this;
    }
    TagsInput.prototype.render = function () {
        var _a = this.props, tags = _a.tags, props = tslib_1.__rest(_a, ["tags"]);
        return (React.createElement(Input, tslib_1.__assign({}, props, { beforeInput: this.renderTags(), onKeyDown: this.handleInputKeyDown, onChange: this.handleInputChange, value: this.state.value, skin: s, refInput: this.refInput })));
    };
    TagsInput.prototype.renderTags = function () {
        var _this = this;
        return (React.createElement("div", { className: s['tags-container'] }, this.state.tags.map(function (tag) { return (React.createElement(TagButton, { value: tag, view: "b14", className: s['tag-button'], onClick: _this.handleRemoveTag },
            React.createElement(React.Fragment, null,
                React.createElement(CloseIconBold, { className: s['tag-icon-close'], size: IconSize.SMALL }),
                tag))); })));
    };
    TagsInput.prototype.addTag = function (tagname) {
        var tags = this.state.tags;
        var trimmedValue = trim(tagname);
        if (trimmedValue && tags.length < MAXIMUM_NUMBER_OF_TAGS) {
            this.setState({ tags: tags.concat([trimmedValue]), value: '' });
        }
    };
    TagsInput.prototype.removeTag = function (tagname) {
        this.setState({
            tags: this.state.tags.filter(function (tag) { return tag !== tagname; }),
        });
    };
    TagsInput.prototype.popTag = function () {
        var tags = this.state.tags;
        if (tags.length > 0) {
            this.setState({ tags: tags.slice(0, tags.length - 1) });
        }
    };
    TagsInput.defaultProps = defaultProps;
    return TagsInput;
}(React.Component));
export default TagsInput;
//# sourceMappingURL=TagsInput.js.map